import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifySmsComponent } from './verify-sms.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    VerifySmsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule
  ]
})
export class VerifySmsModule { }
